import React, { FC, useEffect, useState, useCallback, useRef } from "react";

import { AxiosError } from "axios";
import { Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import useSpinnerLoader from "../../../../shared/components/spinner-loader";
import TableHeaderOrdering, {
  Header,
  OrderData,
} from "../../../../shared/components/table-header-ordering";
import { notificationService } from "../../../../shared/services/notification-service";
import TableRowNoData from "../../../../shared/components/molecules/commons/table-row-no-data";
import { HrOnlineService } from "../../../../shared/services/Report/HrOnline/hr-online";
import {
  Document,
  Page,
  View,
  Text,
  PDFDownloadLink,
  Font,
} from "@react-pdf/renderer";

import moment from "moment";

Font.register({
  family: "kanit-regular",
  src: "https://fonts.gstatic.com/s/sarabun/v17/DtVjJx26TKEr37c9WBI.ttf",
});
Font.register({
  family: "kanit-200",
  src: "https://fonts.gstatic.com/s/sarabun/v17/DtVmJx26TKEr37c9YL5rulw.ttf",
});

const zw = "\u200B";  


const thaiMonths = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม",
];

const ReportEmployeeCountByEducationLevelListPage: FC = () => {
  const [queryParams, setQueryParams] = useState<any>({
    ordering_field: "",
    ordering: "",
    page: 1,
    page_size: 10,
  });
  const [data, setData] = useState<any>([]);
  const [dataExport, setDataExport] = useState<any>([]);
  const { loaderComponent, startLoading, stopLoading } = useSpinnerLoader();
  const loadingRef = useRef({ startLoading, stopLoading });
  loadingRef.current = { startLoading, stopLoading };

  const headers: Header[] = [
    {
      label: "ระดับการศึกษา",
      field: "graduation_level",
      order: null,
      isOrder: true,
    },
    {
      label: "จำนวน",
      field: "total_count",
      order: null,
      isOrder: true,
    },
    {
      label: "ร้อยละ",
      field: "average_percentage",
      order: null,
      isOrder: true,
    },
  ];

  const fetchData = useCallback(
    async (params: any) => {
      loadingRef.current.startLoading();
      try {
        const result =
          await HrOnlineService.getReportEmployeeCountByEducationLevelList(
            params
          );
        setData(result);
        setDataExport(result);
      } catch (error) {
        const err = error as AxiosError;
        notificationService.dangerNotification(
          "โหลดข้อมูลไม่สำเร็จ",
          err.message
        );
      } finally {
        loadingRef.current.stopLoading();
      }
    },
    [queryParams.ordering_field, queryParams.ordering]
  );

  const tableRowNoData = () => {
    if (data.rows?.length === 0) {
      return <TableRowNoData colspan={7} />;
    }
    return null;
  };

  const PDF: React.FC<{ data: any }> = ({ data }) => (
    <Document>
      <Page size="A4" style={{ padding: 10 }}>
        <View>
          <Text
            style={{
              fontFamily: "kanit-regular",
              fontSize: 16,
              textAlign: "center",
              marginBottom: 1,
            }}
          >
            {"องค์การตลาดเพื่อเกษตรกร" + zw}
          </Text>

          <Text
            style={{
              fontFamily: "kanit-regular",
              fontSize: 16,
              textAlign: "center",
              width: "100%",
              marginBottom: 1,
            }}
          >
            {"รายงานแบ่งประเภท :  ระดับการศึกษา" + zw}
          </Text>

          <Text
            style={{
              fontFamily: "kanit-regular",
              fontSize: 16,
              textAlign: "center",
              marginBottom: 1,
            }}
          >
            {"ประจำวันที่" + zw}{" "}
            {moment().format("D") +
              " " +
              thaiMonths[moment().month()] +
              " " +
              (moment().year() + 543) +
              zw}
          </Text>

          {/* ตาราง - ครอบทั้งตารางด้วย View เดียว */}
          <View
            style={{
              border: "1px solid black",
            }}
          >
            {/* หัวตาราง */}
            <View
              style={{
                flexDirection: "row",
                borderBottom: "1px solid black",
                fontFamily: "kanit-regular",
                fontSize: 11,
              }}
              fixed
            >
              <Text
                style={{
                  width: "33.33%",
                  textAlign: "center",
                  padding: 5,
                  borderRight: "1px solid black",
                }}
              >
                {"ระดับการศึกษา" + zw}
              </Text>
              <Text
                style={{
                  width: "33.33%",
                  textAlign: "center",
                  padding: 5,
                  borderRight: "1px solid black",
                }}
              >
                {"จำนวน" + zw}
              </Text>
              <Text
                style={{
                  width: "33.34%",  
                  textAlign: "center",
                  padding: 5,
                }}
              >
                {"ร้อยละ" + zw}
              </Text>
            </View>

            {data.rows?.map((item: any, index: any) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  borderBottom: "1px solid black",
                fontFamily: "kanit-200",
                fontSize: 10,
                }}
              >
                <Text
                  style={{
                    width: "33.33%",
                    textAlign: "left",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.graduation_level + zw}
                </Text>
                <Text
                  style={{
                    width: "33.33%",
                    textAlign: "center",
                    padding: 5,
                    borderRight: "1px solid black",
                  }}
                >
                  {item.total_count + zw}
                </Text>
                <Text
                  style={{
                    width: "33.34%",
                    textAlign: "center",
                    padding: 5,
                  }}
                >
                  {item.average_percentage + zw}
                </Text>
              </View>
            ))}

            {/* รวมทั้งหมด */}
            <View
              style={{
                flexDirection: "row",
                borderBottom: "1px solid black",
                fontFamily: "kanit-regular",
                fontSize: 10,
              }}
            >
              <Text
                style={{
                  width: "33.33%",
                  textAlign: "center",
                  padding: 5,
                  fontWeight: "bold",
                  borderRight: "1px solid black",
                  }}
              >
                {"รวม" + zw}
              </Text>
              <Text
                style={{
                  width: "33.33%",
                  textAlign: "center",
                  padding: 5,
                  fontWeight: "bold",
                  borderRight: "1px solid black",
                }}
              >
                {data.rows ? data.rows[0].total_sum : 0 + zw}
              </Text>
              <Text
                style={{
                  width: "33.34%",
                  textAlign: "center",
                  padding: 5,
                  fontWeight: "bold",
                }}
              >
                {"100" + zw}
              </Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );

  useEffect(() => {
    fetchData(queryParams);
  }, [fetchData]);

  return (
    <>
      <div className="d-flex justify-content-between py-4">
        <h2 className="text-mof-primary m-0">รายงานแบ่งประเภท :  ระดับการศึกษา</h2>
      </div>
      {loaderComponent}
      <div className="row">
        <div className="col-sm-12 col-md-12 d-flex justify-content-end">
          <PDFDownloadLink
            document={<PDF data={dataExport} />}
            fileName={`รายงานระดับการศึกษา_${moment().format("DDMMYYYY")}.pdf`}
          >
            {
              (({ loading }: any) => (
                <Button
                  variant="primary"
                  className="btn-action btn-mof-primary me-2"
                  disabled={loading}
                >
                  <FontAwesomeIcon icon={faFileExport} className="me-2" />
                  {loading ? "Loading..." : "Export"}
                </Button>
              )) as any
            }
          </PDFDownloadLink>
        </div>
      </div>

      <div className="overflow-auto mt-3">
        <Table striped bordered hover>
          <thead>
            <TableHeaderOrdering
              headers={headers}
              onChangeOrder={(orderData: OrderData) => {
                setQueryParams({
                  ...queryParams,
                  ordering_field: orderData.field,
                  ordering: orderData.order,
                });
              }}
              isShow={true}
            />
          </thead>
          <tbody>
            {data.rows?.map((data: any, index: any) => {
              return (
                <ReportEmployeeCountByEducationLevelRow key={index} {...data} />
              );
            })}

            <tr style={{ fontWeight: "bold" }}>
              <td>รวม</td>
              <td>{data.rows ? data.rows[0].total_sum : 0}</td>
              <td>100</td>
            </tr>
            {tableRowNoData()}
          </tbody>
        </Table>
      </div>
    </>
  );
};

const ReportEmployeeCountByEducationLevelRow: FC<any> = ({
  graduation_level,
  total_count,
  average_percentage,
}) => {
  return (
    <tr>
      <td style={{ fontFamily: "'Kanit', sans-serif" }}>{graduation_level === 'ต่ำกว่า ปวช./มัธยมศึกษาปีที่ 6' ? 'ต่ำกว่า ปวช./มัธยมศึกษาปีที่ 6' + zw : graduation_level + zw} </td>
      <td>{total_count}</td>
      <td>{average_percentage}</td>
    </tr>
  );
};

export default ReportEmployeeCountByEducationLevelListPage;
